import {  reactive, not, Span, Div, Button, Checkbox, Input, NumberInput, Label, P, Br  } from 'alkali'
import RadioButtons from '../../components/generic/RadioButtons'
import { currentAnalysisSelections, updateAnalysis, analysisType  } from 'model/SearchQuery'
import { selectedOutcomes } from 'model/EvidenceSearch'
import Dialog from '../generic/DialogAlkali'
import Widget from '../generic/WidgetAlkali'
import app from 'app/app'
import SelectivityDropdown from 'components/generic/SelectivityDropdown'
import { Toggle } from 'components/generic/Toggle'

export class AnalysisSettings extends Dialog('.analysis-settings-dialog') {
	get defaults() {
		return {
			head: {
				titleText: 'Analysis Settings',
			},
			id: 'settings-dialog',
			loader: false,
			foot: {},

		}
	}

	ready() {
		let settings = reactive(Object.assign({}, currentAnalysisSelections.settings.valueOf()))
		let outcomeType = selectedOutcomes.valueOf()[0]?.type
		this.footer.append( Button('.btn', {
			textContent: 'Save',
			onclick: (this) => {
				let updatedSettings = settings.valueOf()
				for (let key in updatedSettings) {
					if (currentAnalysisSelections.settings.get(key) != updatedSettings[key])
						currentAnalysisSelections.settings.set(key, updatedSettings[key])
				}
				this.hide()
			}
		}))
		this.body.className += ' analysis-settings-type-' + analysisType
		outcomeType = outcomeType == 'Binary' || outcomeType == 'Incidence' ? outcomeType : 'Continuous'
		let isNotPeto = analysisType != 'direct' || settings.effects.to(effects => effects != 'fixed' || settings.property('fixedEffectsMethod').to(method => method != 'peto'))
		let measure = outcomeType == 'Binary' ? 'measureBin' : outcomeType == 'Incidence' ? 'measureRate' : 'measureCont'
		let priors = settings.property('hyPrior')
		function forMeasure(type, measure, isDefault?) {
			return settings.to(settings =>
				!settings.useSMD && (settings[type] == measure || isDefault && !settings[type]))
		}
		let detailed = reactive(false)
		this.body.append(
			analysisType != 'evidence-table'
				? [
					Widget(
						{
							head: {
								title: 'Analysis Effects and Scaling',
							},
							classes: {
								'analysis-settings-detailed': detailed,
							},
						},
						[
							Div('.user-settings.currently-applicable.linear-effects-model', [
								Span(['Linear Effects Model']),
								Button({
									content: 'Random Effects',
									title: 'Random effects model assumes that studies are heterogenous in population, design, timelines, and methods, and have potentially random confounding factors that can influence treatment effects, and additional intra-study variance is included.',
									onclick() {
										settings.effects.put('random')
									},
									classes: {
										selected: settings.effects.to((effects) => effects == 'random' || !effects),
									},
								}),
								Button({
									textContent: 'Fixed Effects',
									title: 'Fixed effects model assumes that studies are homogeneous in population, design, timelines, and methods and variance is purely reported aleatoric/observed. This is not recommended for typical meta-analysis of studies.',
									onclick() {
										settings.effects.put('fixed')
									},
									classes: {
										selected: settings.effects.to((effects) => effects == 'fixed'),
									},
								}),
							]),
							Div(
								'.user-settings.binary-scale',
								{
									classes: { 'different-outcome': outcomeType != 'Binary' },
								},
								[
									Span(['Binary Scale']),
									/*					analysisType != 'cohort' ? null :
				Button({
					textContent: 'PFT',
					title: 'Freemen-Tukey double arcsine transformed proportion',
					onclick() {
						settings.set('measureBin', 'PFT')
					},
					classes: {
						selected: settings.property('measureBin').to(measureBin => measureBin == 'PFT')
					},
				}),*/
									analysisType == 'bayesian'
										? null
										: Button({
												display: isNotPeto,
												content: analysisType == 'cohort' ? 'Raw (PR)' : 'Risk Difference',
												title: 'Use a direct linear scale for analysis',
												onclick() {
													settings.set('useSMD', false)
													settings.set('measureBin', 'RD')
												},
												classes: {
													selected: forMeasure('measureBin', 'RD'),
												},
										  }),
									Button({
										textContent: analysisType == 'cohort' ? 'Odds (PLO)' : 'Odds Ratio',
										title: 'Use a logarithmic scale of odds ratio for analysis',
										onclick() {
											settings.set('useSMD', false)
											settings.set('measureBin', 'OR')
										},
										classes: {
											selected: forMeasure('measureBin', 'OR'),
										},
									}),
									Button({
										display: isNotPeto,
										content: analysisType == 'cohort' ? 'Risk (PLN)' : 'Risk Ratio',
										title: 'Use a logarithmic scale for analysis',
										onclick() {
											settings.set('useSMD', false)
											settings.set('measureBin', 'RR')
										},
										classes: {
											selected: forMeasure('measureBin', 'RR', true),
										},
									}),
									/*analysisType == 'direct' ? Button({
										textContent: '√sin⁻¹',
										title: 'Use arcsine square root transformed risk difference scale for analysis',
										onclick() {
											settings.set('useSMD', false)
											settings.set('measureBin', 'AS')
										},
										classes: {
											selected: forMeasure('measureBin', 'AS'),
										},
									}) : null,*/
									Button({
										display: analysisType == 'bayesian',
										textContent: 'Hazard Ratio',
										onclick() {
											settings.set('useSMD', false)
											settings.set('measureBin', 'HR')
										},
										classes: {
											selected: forMeasure('measureBin', 'HR'),
										},
									})
								]
							),
							Div(
								'.user-settings.continuous-scale',
								{
									classes: { 'different-outcome': outcomeType != 'Continuous' },
								},
								[
									Span(['Continuous Scale']),
									Button({
										content:
											analysisType == 'cohort' ? 'Raw Mean (MN)' : 'Mean Difference (MD)',
										title: 'Use a direct linear scale for analysis',
										onclick() {
											settings.set('useSMD', false)
											settings.set('measureCont', 'MD')
										},
										classes: {
											selected: forMeasure('measureCont', 'MD', true),
										},
									}),
								]
							),
							Div(
								'.user-settings.incidence-rate-scale',
								{
									classes: { 'different-outcome': outcomeType != 'Incidence' },
								},
								[
									Span(['Incidence Rate Scale']),
									Button({
										content: 'IRR',
										onclick() {
											settings.set('useSMD', false)
											settings.set('measureRate', 'IRR')
										},
										classes: {
											selected: forMeasure('measureCont', 'IRR', true),
										},
									})
								]
							),
							(analysisType == 'auto' || analysisType == 'frequentist' || analysisType == 'direct') ?
							Div(
								'.user-settings.standardized-mean-difference',
								[
									Button({
										content: 'Standardized Mean Difference (SMD)',
										title: 'Using Standardized Mean Difference (SMD) allows you to combine different units and scales in one analysis',
										onclick() {
											settings.set('useSMD', true)
										},
										classes: {
											selected: settings.property('useSMD').to(Boolean),
										},
									})
								]
							) : null,
						]),
				  Widget(
						{
							head: {
								title: 'Analysis Settings and Details',
							},
							classes: {
								'analysis-settings-detailed': detailed,
							},
						},
						[
							Div(
								'.user-settings.chains',
								{
									display: analysisType == 'bayesian',
								},
								[
									Span(['Chains']),
									SelectivityDropdown('.analysis-setting-dropdown', {
										showSearchInputInDropdown: false,
										value: withDefault(settings.property('nChain'), 2),
										items: [
											{ text: '2', id: 2 },
											{ text: '4', id: 4 },
											{ text: '6', id: 6 },
										],
									}),
								]
							),
							Div(
								'.user-settings.iterations',
								{
									display: analysisType == 'bayesian',
								},
								[
									Span(['Iterations']),
									NumberInput('.analysis-setting-input', {
										value: withDefault(settings.property('nIter'), 20000),
									}),
								]
							),
							Div(
								'.user-settings.burn-in-iterations',
								{
									display: analysisType == 'bayesian',
								},
								[
									Span(['Burn-in Iterations']),
									NumberInput('.analysis-setting-input', {
										value: withDefault(settings.property('nAdapt'), 5000),
									}),
								]
							),
							Div(
								'.user-settings.seed',
								{
									display: analysisType == 'bayesian',
								},
								[
									Span(['Randomization seed (integer)']),
									NumberInput('.analysis-setting-input', {
										placeholder: 'Randomized each time',
										valueAsNumber: settings.property('seed'),
									}),
								]
							),
							Div(
								'.user-settings.random-effects',
								{
									display:
										analysisType != 'bayesian' &&
										analysisType != 'frequentist' &&
										settings.effects.to((effects) => effects == 'random' || !effects),
								},
								[
									Span(['Random Effects Estimation Method']),
									SelectivityDropdown('.analysis-setting-dropdown', {
										value: withDefault(settings.property('effectsMethod'), 'SJ'),
										items: [
											{
												text: 'Sidik-Jonkman',
												id: 'SJ',
											},
											{
												text: 'DerSimonian-Laird',
												id: 'DL',
											},
											{
												text: 'Hedges',
												id: 'HE',
											},
											{
												text: 'Hunter-Schmidt',
												id: 'HS',
											},
											{
												text: 'Maximum-Likelihood (ML)',
												id: 'ML',
											},
											{
												text: 'Restricted ML',
												id: 'REML',
											},
											{
												text: 'Empirical Bayes',
												id: 'EB',
											},
										],
										showSearchInputInDropdown: false,
									}),
								]
							),
							Div(
								'.user-settings.fixed-effects',
								{
									display:
										analysisType != 'bayesian' &&
										analysisType != 'frequentist' &&
										outcomeType != 'Continuous' &&
										settings.effects.to((effects) => effects == 'fixed'),
								},
								[
									Span(['Fixed Effects Estimation Method']),
									SelectivityDropdown('.analysis-setting-dropdown', {
										value: withDefault(settings.property('fixedEffectsMethod'), 'uni'),
										items: settings.property('measureBin').to((measureBin) => [
											{
												text: 'Standard/Linear',
												id: 'uni',
											},
											{
												text: 'Mantel-Haenszel',
												id: 'mh',
											},
											...(measureBin == 'OR' && outcomeType == 'Binary'
												? [
														{
															text: 'Peto',
															id: 'peto',
														},
												  ]
												: []) /*, {
													text: 'Generalized-Linear Model (Binomial/Poisson Distribution)',
													id: 'glmm',
												},*/,
										]),
										showSearchInputInDropdown: false,
									}),
								]
							),
							analysisType == 'bayesian' || analysisType == 'frequentist' || analysisType == 'auto' ?
							Div(
								'.user-settings.sort-by',
								[
									Span(['Sort treatments by (for NMAs)']),
									Button({
										content: 'P-Score',
										onclick() {
											settings.set('sortBy', 'pscore')
										},
										classes: {
											selected: settings.property('sortBy').to(sortBy => !sortBy || sortBy == 'pscore'),
										},
									}),
									Button({
										content: 'Effect',
										onclick() {
											settings.set('sortBy', 'effect')
										},
										classes: {
											selected: settings.property('sortBy').to(sortBy => sortBy == 'effect'),
										},
									}),
								]
							) : null,

							Div(
								'.user-settings.analysis-direction',
								[
									Span(['Analysis Direction']),
									Button({
										content: 'Reverse, larger to left',
										onclick() {
											settings.set('reverseDirection', true)
										},
										classes: {
											selected: settings.property('reverseDirection'),
										},
									}),
									Button({
										content: 'Standard, larger to right',
										onclick() {
											settings.set('reverseDirection', false)
										},
										classes: {
											selected: not(settings.property('reverseDirection')),
										},
									}),
								]
							),
							analysisType == 'bayesian'
								? Div('.user-settings.priors', [
									Span(['Priors']),
									SelectivityDropdown('.analysis-setting-dropdown', {
										showSearchInputInDropdown: false,
										value: withDefault(priors, 'auto'),
										items: [
											{ id: 'auto', text: 'Automatic (heuristic uniform)' },
											{ id: 'dunif', text: 'Uniform for standard deviation' },
											{ id: 'dlnorm', text: 'Log-N for variance' },
											{ id: 'dgamma', text: 'Gamma for precision' },
										],
									}),
									Div('.priors-settings', { display: priors.to(priors => priors == 'dunif') }, [
										Label(['Lower:', NumberInput('.analysis-setting-input', { valueAsNumber: settings.property('lower')})]),
										Label(['Upper:', NumberInput('.analysis-setting-input', { valueAsNumber: settings.property('upper')})]),
									]),
									Div('.priors-settings', { display: priors.to(priors => priors == 'dlnorm') }, [
										Label(['Mean:', NumberInput('.analysis-setting-input', { valueAsNumber: settings.property('mean')})]),
										Label(['SD:', NumberInput('.analysis-setting-input', { valueAsNumber: settings.property('sd')})]),
									]),
									Div('.priors-settings', { display: priors.to(priors => priors == 'dgamma') }, [
										Label(['Rate:', NumberInput('.analysis-setting-input', { valueAsNumber: settings.property('rate')})]),
										Label(['Shape:', NumberInput('.analysis-setting-input', { valueAsNumber: settings.property('shape')})]),
									]),
								]) : null,
							/*analysisType == 'bayesian'
								? Div(
										'.user-settings.model-type',
										{
											display: true,
										},
										[
											Span(['Model Type']),
											Button({
												content: 'Consistency',
												onclick() {
													settings.set('consistencyModel', 'cons')
												},
												classes: {
													selected: settings
														.property('consistencyModel')
														.to((value) => value == 'cons' || !value),
												},
											}),
											Button({
												content: 'Unrelated mean effects',
												onclick() {
													settings.set('consistencyModel', 'ume')
												},
												classes: {
													selected: settings
														.property('consistencyModel')
														.to((value) => value == 'ume'),
												},
											}),
											Button({
												content: 'Unrelated study effects',
												onclick() {
													settings.set('consistencyModel', 'use')
												},
												classes: {
													selected: settings
														.property('consistencyModel')
														.to((value) => value == 'use'),
												},
											}),
										]
								  ) : null,*/
							analysisType == 'bayesian'
								? Div(
										'.user-settings.thinning-factor',
										{
											display: true,
										},
										[
											Span(['Thinning factor']),
											NumberInput('.analysis-setting-input', {
												value: withDefault(settings.property('thin'), 10),
											}),
										]
								  ) : null,
							/*	Not able to implement yet

				Div( '.user-settings.include-anohe', {
					display: true,
				}, [
					Span(['Include ANOHE']),
					Button({
						content: 'Yes',
						onclick() {
							settings.set('ANOHE', 'Yes')
						},
						classes: {
							selected: settings.property('ANOHE').to(value => value == 'Yes')
						},
					}),
					Button({
						content: 'No',
						onclick() {
							settings.set('trimAndFill', false)
						},
						classes: {
							selected: settings.property('trimAndFill').to(value => value == false)
							settings.set('ANOHE', 'No')
						},
						classes: {
							selected: settings.property('ANOHE').to(value => value == 'No')
						},
					}),
				]),
				*/
							Div( '.user-settings.confidence-level', {
									display: true,
								}, [
									Span(['Confidence Level']),
									Button({
										content: '90%',
										onclick() {
											settings.set('confidenceLevel', 90)
										},
										classes: {
											selected: settings.property('confidenceLevel').to(value => value == 90)
										},
									}),
									Button({
										content: '95%',
										onclick() {
											settings.set('confidenceLevel', 95)
										},
										classes: {
											selected: settings.property('confidenceLevel').to(value => value == 95 || value == null)
										},
									}),
									Button({
										content: '99%',
										onclick() {
											settings.set('confidenceLevel', 99)
										},
										classes: {
											selected: settings.property('confidenceLevel').to(value => value == 99)
										},
									}),
								]),
							Div( '.user-settings.continuity-correction', {
									display: analysisType != 'bayesian' &&
										settings.property('measureBin').to(measure =>
											measure != 'RD' && measure != 'PR' && measure != 'MD'),
								}, [
									Span(['Continuity Correction']),
									Button({
										content: 'None',
										title: 'Studies with zero events (or 100% with odds ratio) will be excluded from analysis',
										onclick() {
											settings.set('continuityCorrection', 0)
										},
										classes: {
											selected: settings.property('continuityCorrection').to(value => value == 0.0)
										},
									}),
									Button({
										content: '0.1',
										title: 'Continuity correction of 0.1 will be applied',
										onclick() {
											settings.set('continuityCorrection', 0.1)
										},
										classes: {
											selected: settings.property('continuityCorrection').to(value => value == 0.1)
										},
									}),
									Button({
										content: '0.5',
										title: 'Continuity correction of 0.5 will be applied',
										onclick() {
											settings.set('continuityCorrection', 0.5)
										},
										classes: {
											selected: settings.property('continuityCorrection').to(value => value == 0.5 || value == null)
										},
									}),
								]),
							Div( '.user-settings', {
									display: analysisType == 'direct',
								}, [
									Span(['Test Statistics']),
									Button({
										content: 'Knapp and Hartung',
										onclick() {
											settings.set('testStatistics', 'knha')
										},
										classes: {
											selected: settings.property('testStatistics').to(value => value == 'knha')
										},
									}),
									Button({
										content: 'Normal Distribution',
										onclick() {
											settings.set('testStatistics', null)
										},
										classes: {
											selected: settings.property('testStatistics').to(value => value == null)
										},
									}),
								]), /*
								Div( '.user-settings', {
										display: analysisType == 'direct',
									}, [
										Span(['Trim and Fill']),
										Button({
											content: 'Yes',
											onclick() {
												settings.set('trimAndFill', true)
											},
											classes: {
												selected: settings.property('trimAndFill').to(value => value == true)
											}}),
										Button({
											content: 'No',
											onclick() {
												settings.set('trimAndFill', false)
											},
											classes: {
												selected: settings.property('trimAndFill').to(value => value == false)
											}})
									]),*/
						]
				  )]
				: 
				  Div([
						Widget(
							{
								head: {
									title: 'Report Settings',
								},
							},
							[
								reactive(app.user).to((user) => Boolean(user?.IsInternal))
									? Div('.user-settings.report-settings', {}, [
											Span(['Table Orientation: ']),
											Div('.toggle-container', [
												Span(['Long']),
												Toggle({
													id: 'table-orientation',
													checked: withDefault(settings.property('evidenceTableOrientation'), false),
													name: 'table orientation'
												}),
												Span(['Wide']),
											]),
									  ])
									: Div('.user-settings.report-settings', {}, [
											Span(['Table Orientation: ']),
											Div('.toggle-container', [Span(['Long'])]),
									  ]),
								reactive(app.user).to((user) => Boolean(user?.IsInternal))
									? Div('.user-settings.report-settings', {}, [
											Span(['Version']),
											NumberInput('.analysis-setting-input', {
												value: withDefault(settings.property('evidenceTableVersion'), 1.1),
											}),
									  ]) : null,
							]
						),
				  ])
		)
	}
}
function withDefault(variable, defaultValue) {
	return variable.to(value => value || defaultValue, value => variable.put(value))
}
